import React from "react";
import { connect } from "react-redux";
import CustomLabel from "../../../sub/CustomLabel";
import Paginator from "../../../sub/Paginator";
import { FormattedMessage, injectIntl } from "react-intl";
import Util from "../../../../util/Util";
import GroupsListingRow from "./GroupsListingRow";
import { Button, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "../../../sub/Icon";
import TableToolbar from "../../../sub/bootstrap/TableToolbar";
import GroupAddModal from "../GroupsAdd/GroupAddModal";
import GroupsListingPharmaciesModal from "./GroupsListingPharmaciesModal";
import GroupsListingUsersModal from "./GroupsListingUsersModal";

class GroupsListing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      nameFilter: "",
    };

    this.paginator = new Paginator(this);
  }

  closeModal() {
    this.setState({ modal: null });
  }

  openGroupModal(group) {
    this.setState({
      modal: <GroupAddModal group={group} close={() => this.closeModal()} />,
    });
  }

  openUsersModal(group) {
    this.setState({
      modal: (
        <GroupsListingUsersModal
          group={group}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  openPharmaciesModal(group) {
    this.setState({
      modal: (
        <GroupsListingPharmaciesModal
          group={group}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  areResultsFiltered = () => {
    return !Util.emptyString(this.state.nameFilter);
  };

  resetSearchFields() {
    this.setState({
      nameFilter: "",
    });
  }

  render() {
    this.paginator.init(this.props.groups.length);
    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    const groupsNodes =
      this.props.groups !== undefined &&
      this.props.groups.length > 0 &&
      this.props.groups.map((group) => {
        if (this.state.nameFilter && this.state.nameFilter !== "") {
          if (
            group.name
              .toUpperCase()
              .indexOf(this.state.nameFilter.toUpperCase()) === -1
          )
            return null;
        }

        if (!this.paginator.keep()) return null;

        return (
          <GroupsListingRow
            key={group._id}
            group={group}
            openUsersModal={(group) => this.openUsersModal(group)}
            openPharmaciesModal={(group) => this.openPharmaciesModal(group)}
            openGroupModal={(group) => this.openGroupModal(group)}
          />
        );
      });

    //******** RESET BUTTON  ************/
    const resetSearchButton = () => {
      let button = (
        <button className="btn btn-outline-secondary" disabled>
          <Icon icon="filter" />
        </button>
      );

      if (this.areResultsFiltered() && !disableFormInput) {
        return (
          <div>
            <OverlayTrigger
              delay={{ hide: 0, show: 0 }}
              overlay={(props) => (
                <Tooltip {...props}>
                  {<FormattedMessage id="Remove.Filter" />}
                </Tooltip>
              )}
              placement="bottom"
            >
              <button
                id="searchFilterBtn"
                className="btn btn-warning"
                onClick={() => this.resetSearchFields()}
              >
                <Icon icon="filter" />
              </button>
            </OverlayTrigger>
          </div>
        );
      } else {
        return button;
      }
    };

    return (
      <Container fluid>
        <TableToolbar>
          <CustomLabel
            label={this.props.intl.formatMessage({
              id: "Name",
            })}
            htmlFor="search_group"
            labelClassName="my-1 mr-2"
          />
          <input
            id="search_group"
            className="form-control form-control-sm mr-sm-3"
            type="search"
            onChange={(e) => {
              this.setState({ nameFilter: e.target.value });
            }}
            placeholder={this.props.intl.formatMessage({ id: "Name" })}
            disabled={disableFormInput}
            value={this.state.nameFilter}
          />

          {resetSearchButton()}
          <Button
            variant="info"
            className="ml-auto"
            onClick={() => this.openGroupModal()}
          >
            <FormattedMessage id="Group.Add" />
          </Button>
        </TableToolbar>

        <table className="table tablee4mad">
          <thead>
            <tr>
              <th scope="col" className="col-4">
                <FormattedMessage id="Name" />
              </th>
              <th scope="col" className="col-4">
                <FormattedMessage id="URL" />
              </th>
              <th scope="col" className="col-2">
                <FormattedMessage id="Creation.Date" />
              </th>
              <th
                scope="col"
                className="col-2 align-middle text-center tdaction"
              >
                <FormattedMessage id="Actions" />
              </th>
            </tr>
          </thead>
          <tbody>{groupsNodes}</tbody>
        </table>
        {this.paginator.render()}

        {this.state.modal}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    groups: state.groups,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GroupsListing));
